module.exports = __webpack_public_path__ + "static/media/laminar.dee2b653.png";